export const DEFAULT_PASSWORD_POLICY = Object.freeze({
  min_length: 12,
  require_uppercase: false,
  require_lowercase: false,
  require_digit: false,
  require_special: false,
});

export const normalisePasswordPolicy = (value) => ({
  ...DEFAULT_PASSWORD_POLICY,
  ...(value || {}),
  min_length: Number(value?.min_length || DEFAULT_PASSWORD_POLICY.min_length),
});

export const passwordPolicyErrors = (password, policyValue) => {
  const policy = normalisePasswordPolicy(policyValue);
  const value = password || '';
  const errors = [];
  if (value.length < policy.min_length) errors.push(`Use at least ${policy.min_length} characters.`);
  if (policy.require_uppercase && !/[A-Z]/.test(value)) errors.push('Add an uppercase letter.');
  if (policy.require_lowercase && !/[a-z]/.test(value)) errors.push('Add a lowercase letter.');
  if (policy.require_digit && !/\d/.test(value)) errors.push('Add a digit.');
  if (policy.require_special && !/[!@#$%^&*()_+\-=[\]{};:'",.<>/?\\|`~]/.test(value)) {
    errors.push('Add a special character.');
  }
  return errors;
};
